import { Pipe, PipeTransform } from '@angular/core';
import { Currency } from '../enum';

@Pipe({
	name: 'price',
})
export class PricePipe implements PipeTransform {
	transform(
		priceInPennies: number,
		currency: Currency = Currency.POLISH_ZLOTY,
		showCurrencyCode = true,
		allowNegative = false,
	): string {
		const normalizedPrice = allowNegative ? priceInPennies : Math.max(0, priceInPennies);
		const amount = normalizedPrice / 100;
		if (!showCurrencyCode) {
			return new Intl.NumberFormat('pl-PL', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			}).format(amount);
		}
		return new Intl.NumberFormat('pl-PL', {
			style: 'currency',
			currency: currency,
			currencyDisplay: 'code',
		}).format(amount);
	}
}
